import React, { useState } from 'react';
import { motion } from 'framer-motion';

const avatarOptions = [
  { id: 'avatar1', src: '/images/avatars/avatar1.png', alt: 'Professional avatar' },
  { id: 'avatar2', src: '/images/avatars/avatar2.png', alt: 'Creative avatar' },
  { id: 'avatar3', src: '/images/avatars/avatar3.png', alt: 'Tech avatar' },
  { id: 'avatar4', src: '/images/avatars/avatar4.png', alt: 'Business avatar' },
  { id: 'avatar5', src: '/images/avatars/avatar5.png', alt: 'Casual avatar' },
  { id: 'avatar6', src: '/images/avatars/avatar6.png', alt: 'Artistic avatar' },
];

// Theme options removed

const WelcomeStep = ({ 
  onNext, 
  onAvatarSelect, 
  selectedAvatar
}) => {
  const [name, setName] = useState('');
  const [animation, setAnimation] = useState(false);

  const handleContinue = () => {
    setAnimation(true);
    setTimeout(() => {
      onNext();
    }, 500);
  };

  const handleAvatarSelect = (avatarSrc) => {
    onAvatarSelect(avatarSrc);
    
    // Show a little animation when avatar is selected
    const avatarElement = document.getElementById(avatarSrc);
    if (avatarElement) {
      avatarElement.classList.add('scale-110');
      setTimeout(() => {
        avatarElement.classList.remove('scale-110');
      }, 300);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl font-bold text-center mb-2">Welcome to Job Loop! 👋</h1>
        <p className="text-gray-600 text-center mb-8">
          Let's make your job search journey fun and effective. First, let's personalize your experience!
        </p>

        {/* Name input */}
        <div className="mb-8">
          <label htmlFor="name" className="block text-lg font-medium text-gray-700 mb-2">
            What should we call you? 😊
          </label>
          <input
            type="text"
            id="name"
            className="w-full p-3 border-b-2 border-black focus:border-yellow-400 focus:outline-none transition-all"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        {/* Avatar selection */}
        <div className="mb-8">
          <h2 className="text-lg font-medium text-gray-700 mb-4">
            Choose your avatar 🎭
          </h2>
          <div className="grid grid-cols-3 gap-4">
            {avatarOptions.map((avatar) => (
              <div
                key={avatar.id}
                id={avatar.src}
                className={`relative cursor-pointer transition-all duration-300 ${
                  selectedAvatar === avatar.src ? 'ring-4 ring-yellow-400 ring-offset-2' : 'hover:scale-105'
                }`}
                onClick={() => handleAvatarSelect(avatar.src)}
              >
                <img
                  src={avatar.src}
                  alt={avatar.alt}
                  className="w-full h-auto rounded-lg"
                />
                {selectedAvatar === avatar.src && (
                  <div className="absolute -top-2 -right-2 bg-yellow-400 rounded-full p-1">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Theme selection removed */}

        {/* Continue button */}
        <div className="flex justify-center mt-8">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="px-8 py-3 bg-black text-white font-bold rounded-md shadow-lg hover:bg-gray-800 transition-colors"
            onClick={handleContinue}
            animate={animation ? { scale: [1, 1.2, 0] } : {}}
            transition={{ duration: 0.5 }}
          >
            Let's Get Started!
          </motion.button>
        </div>

        <p className="text-center text-gray-500 mt-4">
          Your profile is already taking shape! 🌱
        </p>
      </motion.div>
    </div>
  );
};

export default WelcomeStep;
